import { Component, HostBinding, Input } from "@angular/core";

import { AbstractButtonItem } from "../base/abstract-button-group";
import { ButtonGroupComponent } from "../button-group/button-group.component";

@Component({
  selector: "ta-button-option",
  template: `
    <ng-content></ng-content>
  `
})
export class ButtonOptionComponent extends AbstractButtonItem<
  ButtonGroupComponent
> {
  @Input()
  @HostBinding("class.button")
  hostClass = true;

  @HostBinding("class.button--selected")
  get checkedClassName(): boolean {
    return this.checked === true;
  }

  @HostBinding("class.button--disabled")
  get disabledClassName(): boolean {
    return this.disabled === true;
  }

  @HostBinding("class.button--touched")
  get touchedClassName(): boolean {
    return this.touched === true;
  }
}
